import { lazy, Suspense } from "react";

import RouteLoadingIndicator from "@src/components/RouteLoadingIndicator/RouteLoadingIndicator";

import LoanFlow from "../LoanFlow/LoanFlow.container.lazy";


const LazyContainer = lazy(() => import("./Dashboard.container"));

const Container = () =>
  <Suspense fallback={<RouteLoadingIndicator />}>
    <LoanFlow>
      <LazyContainer />
    </LoanFlow>
  </Suspense>;

export default Container;
